export function formatString(template: string, replacements: Record<string, string>) {
    return template.replace(/{(\w+)}/g, (_, key) => replacements[key] || "");
  }